/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Posts_Errors_Failedtoupdate2Inputs */

const he_posts_errors_failedtoupdate2 = /** @type {(inputs: Posts_Errors_Failedtoupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עדכון הפוסט נכשל`)
};

const en_posts_errors_failedtoupdate2 = /** @type {(inputs: Posts_Errors_Failedtoupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to update post`)
};

/**
* | output |
* | --- |
* | "Failed to update post" |
*
* @param {Posts_Errors_Failedtoupdate2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const posts_errors_failedtoupdate2 = /** @type {((inputs?: Posts_Errors_Failedtoupdate2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Posts_Errors_Failedtoupdate2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_posts_errors_failedtoupdate2(inputs)
	return en_posts_errors_failedtoupdate2(inputs)
});
export { posts_errors_failedtoupdate2 as "posts_errors_failedToUpdate" }